<template>
  <a-modal
    :visible="visible"
    title="用户使用协议"
    @cancel="onCancelEvent"
    @close="onCancelEvent"
  >
    <div style="height:500px;overflow-y:auto;">
      <div>
        <h2>{{ platformConfig.title }}网站用户注册协议</h2>
        <p>本协议是您与{{ platformConfig.shortName }}（网址：{{ platformDomainUrl }}
          ）的所有者（以下简称"{{ platformConfig.shortName }}"）之间就{{
            platformConfig.shortName
          }}服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您勾选“我已阅读并同意以上条款”后，本协议即构成对双方有约束力的法律文件。</p>
        <p>
          <strong>第1条 {{ platformConfig.shortName }}服务条款的确认和接纳</strong>
          <br>1.1
          {{ platformConfig.shortName }}各项电子服务的所有权和运作权归{{
            platformConfig.shortName
          }}所有。用户同意所有注册协议条款并完成注册程序，才能成为{{
            platformConfig.shortName
          }}的正式用户。用户确认本协议条款作为处理双方权利义务的契约始终有效，法律另有强制性规定或双方另有特别约定的依其规定。
          <br>1.2
          用户同意本协议的，即视为用户确认自己具有享受{{ platformConfig.shortName }}服务、下单预订等相应的权利能力和行为能力，能够独立承担法律责任。
          <br>1.3 如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用{{ platformConfig.shortName }}。
          <br>1.4 {{ platformConfig.shortName }}保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
          <br>
        </p>
        <p>
          <strong>第2条 {{ platformConfig.shortName }}服务</strong>
          <br>2.1{{
            platformConfig.shortName
          }}通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及{{
            platformConfig.shortName
          }}规定的情况下，方有权使用{{ platformConfig.shortName }}的相关服务。
          <br>
        </p>
        <p>
          <strong>第3条 用户信息</strong>
          <br>3.1
          用户应自行诚信向{{
            platformConfig.shortName
          }}提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且{{
            platformConfig.shortName
          }}保留终止用户使用{{ platformConfig.shortName }}各项服务的权利。
          <br>3.2
          用户在{{
            platformConfig.shortName
          }}上进行浏览、下单等操作时，涉及用户真实姓名、通信地址、联系电话、电子邮箱等隐私信息的，{{
            platformConfig.shortName
          }}将予以严格保密，除非得到用户的授权或法律另有规定，{{ platformConfig.shortName }}不会向外界披露用户隐私信息。
          <br>3.3
          用户注册成功后，将产生用户名和密码等账号信息，您可以根据{{
            platformConfig.shortName
          }}规定更改您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知{{
            platformConfig.shortName
          }}并向公安机关报案。
          <br>3.4
          用户同意{{ platformConfig.shortName }}拥有通过邮件、短信电话等形式，向在{{
            platformConfig.shortName
          }}注册、下单的用户提供促销活动等告知信息的权利。
          <br>3.5 用户不得将在{{ platformConfig.shortName }}注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
          <br>3.6 用户同意{{ platformConfig.shortName }}有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账户进行证据保全，包括但不限于公证、见证等。
          <br>
        </p>
        <p>
          <strong>第4条 用户依法言行义务</strong>
          <br>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：
          <br>（1）不得传输或发表煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
          <br>（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；
          <br>（3）不得利用{{ platformConfig.shortName }}从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
          <br>（4）不得干扰{{ platformConfig.shortName }}的正常运转，不得侵入{{ platformConfig.shortName }}及国家计算机信息系统；
          <br>（5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；
          <br>（6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
          <br>（7）不得教唆他人从事本条款所禁止的行为；
          <br>（8）不得利用在{{ platformConfig.shortName }}注册的账户进行牟利性经营活动；
          <br>（9）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；用户应关注并遵守{{
            platformConfig.shortName
          }}公布或修改的各类合法规定。{{ platformConfig.shortName }}保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。
          <br>若用户未遵守以上规定的，{{ platformConfig.shortName }}有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。
        </p>
        <p>
          <strong>第5条 其他</strong>
          <br>5.1
          {{
            platformConfig.shortName
          }}尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户提供服务。{{
            platformConfig.shortName
          }}欢迎用户和社会各界提出意见和建议，{{
            platformConfig.shortName
          }}将虚心接受并适时修改本协议及{{ platformConfig.shortName }}上的各类规则。
          <br>5.2
          您点击查阅本协议下方的“我已阅读并同意以上条款”，并勾选“我已阅读并同意以上条款”后，本协议即构成对双方有约束力的法律文件。在法律允许范围内，{{
            platformConfig.shortName
          }}保留对本协议的最终解释权。
          <br>
        </p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <a-button type="primary" @click="onCancelEvent">取 消</a-button>
      </span>
  </a-modal>
</template>

<script>
export default {
  name: 'UserAgreementComponent',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.platformConfig = this.getPlatformConfig()
    this.platformDomainUrl = location.origin
  },
  data() {
    return {
      platformConfig: {},
      platformDomainUrl: ''
    }
  },
  mounted() {
  },
  methods: {
    onCancelEvent() {
      this.$emit('close', {})
    }
  }

}
</script>
<style scoped>
</style>